export function addItemToArray(key, id, data, hours = 12) {
  // Fetch existing array or use an empty array if none exists
  const storedData = localStorage.getItem(key);
  let itemsArray = storedData ? JSON.parse(storedData) : [];

  // Calculate expiry timestamp in milliseconds
  const createdAt = Date.now();
  const expiry = createdAt + hours * 60 * 60 * 1000;

  // Create the new item
  const newItem = {
    id,
    data,
    expiry,
    createdAt
  };

  // Optional: If you want to ensure the ID is unique, you could remove any
  // existing item with the same ID before pushing the new one
  itemsArray = itemsArray.filter(item => item.id !== id);

  // Push the new item
  itemsArray.push(newItem);

  // Save back to localStorage
  localStorage.setItem(key, JSON.stringify(itemsArray));
}

export function getItemsFromArray(key) {
  const storedData = localStorage.getItem(key);

  if (!storedData) {
    return [];
  }

  let itemsArray = JSON.parse(storedData);
  const now = Date.now();

  // Filter out expired items
  itemsArray = itemsArray.filter(item => now < item.expiry);

  // Save the updated array (removing the expired items)
  localStorage.setItem(key, JSON.stringify(itemsArray));

  return itemsArray;
}

/* Usage Example:

// Add an item
addItemToArray("myItems", "user-123", { name: "Alice" }, 12);

// Get all non-expired items
const validItems = getItemsFromArray("myItems");
console.log(validItems);
// [ { id: "user-123", data: { name: "Alice" }, expiry: 1234567890123 } ]

*/
